import { Popconfirm as AntdPopconfirm, type PopconfirmProps as AntdPopconfirmProps } from 'antd';

const Popconfirm = ({ okButtonProps, cancelButtonProps, ...props }: AntdPopconfirmProps) => (
    <AntdPopconfirm
        {...props}
        cancelButtonProps={{
            ...cancelButtonProps,
            style: {
                ...cancelButtonProps?.style,
                borderRadius: '0',
            },
        }}
        okButtonProps={{
            ...okButtonProps,
            style: {
                ...okButtonProps?.style,
                borderRadius: '0',
            },
        }}
        overlayInnerStyle={{
            ...props.overlayInnerStyle,
            borderRadius: '0',
        }}
    />
);

export default Popconfirm;
